import Image from "next/image";

const Steps = (props) => {
	return (
		<div className="pd-steps__container">
			<div className="pd-steps">
				<div className="pd-steps__content">
					<h2 className="pd-steps__header">KROK 01</h2>
					<div className="pd-steps__image">
						<Image unoptimized 
							alt=""
							src="https://przyjazne-deklaracje.pl/resources/images/logo/przyjazne-deklaracje/logo-desktop.svg"
							width={131}
							height={29}
						/>
					</div>
					<p className="pd-steps__description">
						Uzupełnij on-line korzystając z Przyjaznych Deklaracji
					</p>
				</div>
				<div className="pd-steps__arrow">
					<Image unoptimized 
						alt=""
						src="https://przyjazne-deklaracje.pl/resources/images/icons/general/files/arrow.svg"
						width={60}
						height={30}
					/>
				</div>
			</div>
			<div className="pd-steps">
				<div className="pd-steps__content">
					<h2 className="pd-steps__header">KROK 02</h2>
					<div className="pd-steps__image">
						<Image unoptimized 
							alt=""
							src="https://przyjazne-deklaracje.pl/resources/images/icons/general/section/jak-to-dziala/profil-zaufany-logo.svg"
							width={170}
							height={51}
						/>
					</div>
					<p className="pd-steps__description">Podpisz Profilem Zaufanym</p>
				</div>
				<div className="pd-steps__arrow">
					<Image unoptimized 
						alt=""
						src="https://przyjazne-deklaracje.pl/resources/images/icons/general/files/arrow.svg"
						width={60}
						height={30}
					/>
				</div>
			</div>
			<div className="pd-steps">
				<div className="pd-steps__content">
					<h2 className="pd-steps__header">KROK 03</h2>
					<div className="pd-steps__image">
						<Image unoptimized 
							alt=""
							src="https://przyjazne-deklaracje.pl/resources/images/icons/general/section/jak-to-dziala/ePUAP-logo.png"
							width={340}
							height={69}
						/>
					</div>
					<p className="pd-steps__description">Wyślij elektronicznie przez ePUAP</p>
				</div>
			</div>
		</div>
	);
};

export default Steps;
